import React from 'react';
import styled from 'styled-components';
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  Card,
  Typography,
  Tabs,
  InputNumber,
  Upload,
  FloatButton,
  Tooltip,
  Tag,
  Radio,
  DatePicker
} from 'antd';
import {
  EditFilled,
  RocketFilled,
  BellOutlined,
  StopFilled,
  TeamOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  PlusCircleFilled,
  DeleteFilled
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import { withIsMobile } from 'src/utils/responsive';
import { SITE_SIDEBAR_TABS } from 'src/constants/sidebarTabs';
import {
  DEFAULT_EXPERIENCE_CRITERIA,
  DEFAULT_STAR_COUNT,
  MIN_STAR_COUNT,
  MAX_STAR_COUNT,
  makeCriterionKey,
  resolveSiteCriteria,
  resolveStarCount
} from 'src/constants/experienceCriteria';
import Notify from 'src/components/meta/Notification';
import Highlighter from 'react-highlight-words';
import Resizer from 'react-image-file-resizer';
import moment from 'moment';
import { connect } from 'react-redux';
import { getSidebarCollapsed, getUser } from 'src/redux/selectors';

const { Title } = Typography;
const { Column } = Table;
const FormItem = Form.Item;

const { TabPane } = Tabs;
const { Search } = Input;
const { Option } = Select;

const ResponsiveFormWrap = styled.span`
  @media (max-width: 991px) {
    .ant-col {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-row {
      padding-left: 1em !important;
      padding-right: 1em !important;
    }
  }
`;
const StyledTable = styled(Table)`
  @media (max-width: 991px) {
    .ant-table-content,
    .ant-table-body {
      overflow-x: auto !important;
    }
    .ant-table table {
      min-width: 40em;
    }
    .ant-table-thead > tr > th {
      white-space: nowrap;
    }
    .ant-table-cell-fix-right {
      background: #fff;
    }
    .ant-pagination {
      display: flex;
      flex-wrap: wrap;
      row-gap: 0.5em;
    }
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: '';
  }
`;
const StyledInputNumber = styled(InputNumber)`
  font-weight: 500 !important;
  color: #525f7f !important;
  font-size: 15px !important;
  cursor: not-allowed;
  .ant-input-number-disabled .ant-input-number-input {
    font-weight: 500 !important;
    color: #525f7f !important;
    font-size: 15px !important;
    cursor: not-allowed;
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;

function callback(key) {
  console.log(key);
}
const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}

function handleChange(value) {
  console.log(`selected ${value}`);
}
class SitesFormClass extends React.Component {
  state = {
    descriptions: this.props.descriptions,
    mainCatImage: undefined,
    selectedCostCategories: this.props.editSites?.costCategories || [],
    selectedCurrencies: this.props.editSites?.availableCurrencies || [],
    // Copied so edits here don't mutate the site object in redux. A site with
    // nothing configured starts from the built-in defaults.
    experienceCriteria: resolveSiteCriteria(this.props.editSites).map(c => ({
      ...c
    }))
  };

  handleAddCriterion = () => {
    this.setState(prev => ({
      experienceCriteria: [...prev.experienceCriteria, { key: '', label: '' }]
    }));
  };

  handleRemoveCriterion = index => {
    this.setState(prev => ({
      experienceCriteria: prev.experienceCriteria.filter((_, i) => i !== index)
    }));
  };

  handleMoveCriterion = (index, direction) => {
    this.setState(prev => {
      const next = [...prev.experienceCriteria];
      const target = index + direction;
      if (target < 0 || target >= next.length) return null;
      [next[index], next[target]] = [next[target], next[index]];
      return { experienceCriteria: next };
    });
  };

  handleCriterionLabelChange = (index, label) => {
    this.setState(prev => {
      const next = prev.experienceCriteria.map((c, i) =>
        i === index ? { ...c, label } : c
      );

      // Assign the key once, the first time a label is typed, then never touch
      // it again — renaming a criterion must keep its collected reviews.
      if (!next[index].key && label.trim()) {
        next[index].key = makeCriterionKey(
          label,
          next.filter((_, i) => i !== index).map(c => c.key)
        );
      }

      return { experienceCriteria: next };
    });
  };

  handleResetCriteria = () => {
    this.setState({
      experienceCriteria: DEFAULT_EXPERIENCE_CRITERIA.map(c => ({ ...c }))
    });
  };
  componentDidMount = () => {
    const initialCategories = this.props.editSites?.costCategories || [];
    const initialCurrencies = this.props.editSites?.availableCurrencies || [];
    this.setState({ selectedCostCategories: initialCategories });
    this.setState({ selectedCurrencies: initialCurrencies });
    if (this.props.editSites) {
      this.setState({
        mainCatImage: this.props.editSites.mainCatImage
      });
    }
  };
  handleMainCatImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainCatImage: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1000, 1000, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };
  selectItem = value => {
    if (value.substr(0, 4) === 'Add ') {
      let parsedValue = value.substr(4, value.length);
      this.props.form.setFieldsValue({ description: parsedValue });
      let descriptions = this.state.descriptions;
      descriptions.pop();
      descriptions.push({ value: parsedValue });
      this.setState({ descriptions: descriptions });
    }
  };
  searchItem = (value, b) => {
    let descriptions = this.state.descriptions;
    if (descriptions[descriptions.length - 1].value.substr(0, 4) === 'Add ') {
      descriptions.pop();
    }
    if (
      !descriptions.find(
        descriptions => descriptions.value.toLowerCase() === value.toLowerCase()
      ) &&
      value !== ''
    ) {
      descriptions.push({ value: 'Add ' + value });
    }
    this.setState({ descriptions: descriptions });
  };
  handleCostCategoryChange = selectedValues => {
    this.setState({ selectedCostCategories: selectedValues });
  };
  handleCurrenciesChange = selectedValues => {
    this.setState({ selectedCurrencies: selectedValues });
  };
  handleDisplayCurrencyChange = value => {
    const currentCurrencies =
      this.props.form.getFieldValue('availableCurrencies') || [];
    const updated = Array.from(new Set([...currentCurrencies, value]));

    this.props.form.setFieldsValue({
      companyCurrency: value,
      availableCurrencies: updated
    });

    this.handleCurrenciesChange(updated); // update state.selectedCurrencies too if needed
  };
  render() {
    return (
      <ResponsiveFormWrap>
      <Form layout="vertical">
        <Row>
          <Col span={15}>
            <Col span={24}>
              <FormItem label={<span>Site Name</span>}>
                {this.props.form.getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Site Name is required' }],
                  initialValue: this.props.editSites
                    ? this.props.editSites.name
                    : ''
                })(
                  <Input size="large" placeholder={'Please enter Site Name'} />
                )}
              </FormItem>
            </Col>
            {this.props.user.type === 'admin' && (
              <Col span={24} style={{ marginTop: '1em' }}>
                <FormItem
                  label={<span>Linked Inventory Site (for Costs)</span>}
                >
                  {this.props.form.getFieldDecorator('inventorySiteId', {
                    rules: [{ required: false }],
                    initialValue: this.props.editSites
                      ? this.props.editSites.inventorySiteId
                      : undefined
                  })(
                    <Select
                      size="large"
                      placeholder="Select inventory site"
                      allowClear
                    >
                      {(this.props.inventorySites || [])
                        .filter(s => s.siteType !== 'supplierCheck')
                        .map(s => (
                          <Option key={String(s._id)} value={String(s._id)}>
                            {s.name || s.siteName || s.companyName || 'Site'}
                          </Option>
                        ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
            )}

            {this.props.editSites ? (
              <Col span={24} style={{ marginTop: '1em' }}>
                <FormItem label={<span>Rating Link</span>}>
                  {this.props.form.getFieldDecorator('ratingLink', {
                    rules: [
                      { required: false, message: 'Site Name is required' }
                    ],
                    initialValue: this.props.editSites
                      ? `https://www.sproutmanagement.africa/rating/${
                          this.props.editSites._id
                        }`
                      : ''
                  })(
                    <Input
                      disabled
                      size="large"
                      placeholder={'Please enter Site Name'}
                    />
                  )}
                </FormItem>
              </Col>
            ) : null}
            <Col span={24} style={{ marginTop: '1em', display: 'flex' }}>
              <FormItem
                style={{ marginBottom: '1em' }}
                label={<span>Display Currency</span>}
              >
                {this.props.form.getFieldDecorator('companyCurrency', {
                  rules: [{ required: false, message: 'Tags required' }],
                  initialValue: this.props.editSites
                    ? this.props.editSites.companyCurrency
                    : ''
                })(
                  <Select
                    disabled={this.props.editSites ? true : false}
                    size="large"
                    style={{ width: '100%' }}
                    onChange={this.handleDisplayCurrencyChange}
                  >
                    <Option value="R">R (South Africa)</Option>
                    <Option value="Ksh">Ksh (Kenya)</Option>
                    <Option value="TZS">TZS (Tanzanian)</Option>
                    <Option value="USD">USD (Dollar)</Option>
                  </Select>
                )}
              </FormItem>
            </Col>
          </Col>
          <Col span={1} />
          <Col span={8} style={{ marginTop: '-1em' }}>
            <h1
              style={{
                marginBottom: '1em',
                fontSize: '14px',
                fontWeight: 400
                // fontFamily: "Nunito",
              }}
            >
              Site Logo Image
            </h1>
            <Upload
              name="mainCatImage"
              className="avatar-uploader"
              listType="picture-card"
              showUploadList={false}
              beforeUpload={this.beforeUpload}
              customRequest={this.handleImageUpload}
              onChange={this.handleMainCatImage}
              loading={this.state.loading}
              accept="image/*"
            >
              {this.state.mainCatImage ? (
                <img
                  style={{
                    width: '100%',
                    height: '15em',
                    objectFit: 'contain'
                  }}
                  alt="example"
                  src={
                    this.state.mainCatImage.search('data') > -1
                      ? this.state.mainCatImage
                      : process.env.REACT_APP_GLOBAL_SERVER +
                        'sproutmanagement/api/images/' +
                        this.state.mainCatImage
                  }
                />
              ) : (
                <div
                  style={{
                    marginTop: 8
                  }}
                >
                  Upload
                </div>
              )}
            </Upload>
          </Col>
        </Row>
        <Row
          gutter={12}
          style={{
            paddingTop: '1em',
            paddingBottom: '0em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span>Available Currencies</span>}
            >
              {this.props.form.getFieldDecorator('availableCurrencies', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.availableCurrencies
                  : []
              })(
                <Select
                  size="large"
                  mode="tags"
                  style={{ width: '100%' }}
                  onChange={this.handleCurrenciesChange}
                  tokenSeparators={[',']}
                >
                  {['R', 'Ksh', 'TZS', 'USD', 'EUR'].map(cur => (
                    <Option key={cur} value={cur}>
                      {cur}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          {this.state.selectedCurrencies.map(currency => (
            <Col span={4} style={{ marginTop: '1em' }} key={currency}>
              <FormItem label={`FX Rate ${currency}`} style={{}}>
                {this.props.form.getFieldDecorator(`exchange_${currency}`, {
                  initialValue:
                    currency ===
                    this.props.form.getFieldValue('companyCurrency')
                      ? 1
                      : this.props.editSites?.exchange?.[currency] || ''
                  // initialValue: this.props.editSites?.exchange?.[currency] || '',
                })(
                  <Input
                    size="large"
                    type="number"
                    disabled={
                      currency ===
                      this.props.form.getFieldValue('companyCurrency')
                    } // prevent changing display currency rate
                    placeholder={`${currency}`}
                    style={{ width: '93%' }}
                  />
                )}
              </FormItem>
            </Col>
          ))}
        </Row>
        <Row
          gutter={12}
          style={{
            paddingTop: '1em',
            paddingBottom: '0em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem label={<span>Select Restricted Days</span>}>
              {this.props.form.getFieldDecorator('restrictedDays', {
                rules: [
                  { required: false, message: 'Please select restricted days' }
                ],
                initialValue:
                  this.props.editSites && this.props.editSites.restrictedDays
                    ? this.props.editSites.restrictedDays.map(date =>
                        moment(date).format('MM-DD')
                      )
                    : []
              })(
                <>
                  <DatePicker
                    style={{ width: '100%' }}
                    size="large"
                    placeholder="Select restricted dates"
                    format="MM-DD"
                    onChange={date => {
                      if (!date) return; // Handle the case when the date is null

                      const selectedDates =
                        this.props.form.getFieldValue('restrictedDays') || [];
                      const formattedDate = date.format('MM-DD'); // Save only month and day

                      if (!selectedDates.includes(formattedDate)) {
                        this.props.form.setFieldsValue({
                          restrictedDays: [...selectedDates, formattedDate]
                        });
                      }
                    }}
                    // disabledDate={(current) => current && current < moment().startOf('day')}
                  />
                  <div style={{ marginTop: '0.5em' }}>
                    {this.props.form
                      .getFieldValue('restrictedDays')
                      ?.map((date, index) => (
                        <Tag
                          color="#80ce90"
                          style={{ marginTop: '0.5em' }}
                          key={`${date}-${index}`} // Ensure unique key to prevent React rendering issues
                          closable
                          onClose={() => {
                            const currentDates =
                              this.props.form.getFieldValue('restrictedDays') ||
                              [];
                            const newDates = currentDates.filter(
                              (_, i) => i !== index
                            ); // Remove by index safely
                            this.props.form.setFieldsValue({
                              restrictedDays: newDates
                            });
                          }}
                        >
                          {date}
                        </Tag>
                      ))}
                  </div>
                </>
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{ marginTop: '1em', display: 'flex' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span style={{ marginLeft: '0em' }}>Leave</span>}
            >
              {this.props.form.getFieldDecorator('companyLeaveDays', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.companyLeaveDays
                  : ''
              })(
                <InputNumber
                  style={{ width: '90%' }}
                  size="large"
                  placeholder={'Enter Days'}
                />
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{ marginTop: '1em', display: 'flex' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span style={{ marginLeft: '0em' }}>Off</span>}
            >
              {this.props.form.getFieldDecorator('companyOffDays', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.companyOffDays
                  : ''
              })(
                <InputNumber
                  style={{ width: '90%' }}
                  size="large"
                  placeholder={'Enter Days'}
                />
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{ marginTop: '1em', display: 'flex' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span style={{ marginLeft: '0em' }}>Sick</span>}
            >
              {this.props.form.getFieldDecorator('companySickDays', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.companySickDays
                  : ''
              })(
                <InputNumber
                  style={{ width: '90%' }}
                  size="large"
                  placeholder={'Enter Days'}
                />
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{ marginTop: '1em', display: 'flex' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span style={{ marginLeft: '0em' }}>Maternity</span>}
            >
              {this.props.form.getFieldDecorator('companyMaternityDays', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.companyMaternityDays
                  : ''
              })(
                <InputNumber
                  style={{ width: '90%' }}
                  size="large"
                  placeholder={'Enter Days'}
                />
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{ marginTop: '1em', display: 'flex' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span style={{ marginLeft: '0em' }}>Paternity</span>}
            >
              {this.props.form.getFieldDecorator('companyPaternityDays', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.companyPaternityDays
                  : ''
              })(
                <InputNumber
                  style={{ width: '90%' }}
                  size="large"
                  placeholder={'Enter Days'}
                />
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{ marginTop: '1em', display: 'flex' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span style={{ marginLeft: '0em' }}>Compassionate</span>}
            >
              {this.props.form.getFieldDecorator('companyCompassionateDays', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.companyCompassionateDays
                  : ''
              })(
                <InputNumber
                  style={{ width: '90%' }}
                  size="large"
                  placeholder={'Enter Days'}
                />
              )}
            </FormItem>
          </Col>
        </Row>
        <Row
          style={{
            paddingTop: '1em',
            paddingBottom: '0em',
            borderTop: '1px dashed #d9d9d9',
            marginTop: '2em'
          }}
        >
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span style={{}}>Sale Categories</span>}
            >
              {this.props.form.getFieldDecorator('saleCategories', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.saleCategories
                  : []
              })(
                <Select
                  size="large"
                  mode="tags"
                  style={{
                    width: '100%'
                  }}
                  onChange={handleChange}
                  tokenSeparators={[',']}
                >
                  <Option key="Food" value="Food">
                    Food
                  </Option>
                  <Option key="Bar" value="Bar">
                    Bar
                  </Option>
                  <Option key="Spa" value="Spa">
                    Spa
                  </Option>
                  <Option key=" Curio Shop" value=" Curio Shop">
                    Curio Shop
                  </Option>
                  <Option key="Bush Dinner" value="Bush Dinner">
                    Bush Dinner
                  </Option>
                  <Option key="Room Upgrade " value="Room Upgrade ">
                    Room Upgrade
                  </Option>
                </Select>
              )}
            </FormItem>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span>Cost Categories</span>}
            >
              {this.props.form.getFieldDecorator('costCategories', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editSites
                  ? this.props.editSites.costCategories
                  : []
              })(
                <Select
                  size="large"
                  mode="tags"
                  style={{ width: '100%' }}
                  onChange={this.handleCostCategoryChange}
                  tokenSeparators={[',']}
                >
                  {[
                    'Food',
                    'Staff Food',
                    'Bar',
                    'Housekeeping',
                    'Curio Shop',
                    'Maintenance',
                    'Gas',
                    'Kerosene',
                    'Drivers'
                  ].map(cat => (
                    <Option key={cat} value={cat}>
                      {cat}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>

          {this.state.selectedCostCategories.map(category => (
            <Col span={8} style={{ marginTop: '1em' }} key={category}>
              <FormItem
                label={`Daily Budget ${category}`}
                style={{ marginLeft: '1em' }}
              >
                {this.props.form.getFieldDecorator(`budget_${category}`, {
                  initialValue:
                    this.props.editSites?.dailyBudgets?.[category] || ''
                })(
                  <Input
                    size="large"
                    type="number"
                    placeholder={`${category}`}
                    style={{ width: '93%' }}
                  />
                )}
              </FormItem>
            </Col>
          ))}

          <Col span={24} style={{ marginTop: '1em' }}>
            <FormItem
              style={{ marginBottom: '1em', marginLeft: '1em' }}
              label={<span>Sidebar Tabs</span>}
              extra={
                this.props.user.type === 'admin'
                  ? "Which menu items this company's manager users see when they log in. Leave empty to show all of them."
                  : 'Set by your administrator. You can see which tabs your company has, but only an administrator can change them.'
              }
            >
              {this.props.form.getFieldDecorator('sidebarTabs', {
                rules: [{ required: false }],
                initialValue: this.props.editSites
                  ? this.props.editSites.sidebarTabs || []
                  : []
              })(
                <Select
                  size="large"
                  mode="multiple"
                  allowClear
                  // This field controls the editor's own menu, so anyone below
                  // admin could otherwise grant themselves tabs.
                  disabled={this.props.user.type !== 'admin'}
                  placeholder="Select the tabs this company can see"
                  style={{ width: '100%' }}
                >
                  {SITE_SIDEBAR_TABS.map(tab => (
                    <Option key={tab.key} value={tab.key}>
                      {tab.label}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>

          <Col span={24} style={{ marginTop: '2em' }}>
            <Divider orientation="left" orientationmargin={0}>
              Guest Experience Rating
            </Divider>
          </Col>

          <Col span={6} style={{ marginLeft: '1em' }}>
            <FormItem
              label={<span>Stars per Question</span>}
              extra="How many stars guests rate each question out of."
            >
              {this.props.form.getFieldDecorator('experienceStarCount', {
                rules: [{ required: false }],
                initialValue: resolveStarCount(this.props.editSites)
              })(
                <Select size="large" style={{ width: '100%' }}>
                  {Array.from(
                    { length: MAX_STAR_COUNT - MIN_STAR_COUNT + 1 },
                    (_, i) => MIN_STAR_COUNT + i
                  ).map(n => (
                    <Option key={n} value={n}>
                      {n} stars{n === DEFAULT_STAR_COUNT ? ' (default)' : ''}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>

          <Col span={24} style={{ marginTop: '1em', marginLeft: '1em' }}>
            <FormItem
              label={<span>Rating Questions</span>}
              extra="What guests are asked to rate, in the order shown. Renaming a question keeps its existing reviews; removing one hides it from new reviews but past scores are kept and marked as retired."
            >
              <div>
                {this.state.experienceCriteria.map((criterion, index) => (
                  <Row
                    key={`${criterion.key || 'new'}-${index}`}
                    gutter={8}
                    style={{ marginBottom: '0.5em' }}
                  >
                    <Col span={14}>
                      <Input
                        size="large"
                        value={criterion.label}
                        placeholder="e.g. Check-in Experience"
                        onChange={e =>
                          this.handleCriterionLabelChange(index, e.target.value)
                        }
                      />
                    </Col>
                    <Col span={9}>
                      <Button
                        size="large"
                        disabled={index === 0}
                        onClick={() => this.handleMoveCriterion(index, -1)}
                        style={{ marginRight: '0.4em' }}
                      >
                        ↑
                      </Button>
                      <Button
                        size="large"
                        disabled={
                          index === this.state.experienceCriteria.length - 1
                        }
                        onClick={() => this.handleMoveCriterion(index, 1)}
                        style={{ marginRight: '0.4em' }}
                      >
                        ↓
                      </Button>
                      <Button
                        size="large"
                        danger
                        onClick={() => this.handleRemoveCriterion(index)}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>
                ))}

                <Button
                  icon={<PlusCircleFilled style={{ color: 'white' }} />}
                  size="large"
                  onClick={this.handleAddCriterion}
                  style={{
                    backgroundColor: 'black',
                    color: 'white',
                    marginTop: '0.5em',
                    marginRight: '0.6em'
                  }}
                >
                  Add Question
                </Button>
                <Button
                  size="large"
                  onClick={this.handleResetCriteria}
                  style={{ marginTop: '0.5em' }}
                >
                  Reset to Default
                </Button>
              </div>
            </FormItem>
          </Col>
        </Row>
      </Form>
      </ResponsiveFormWrap>
    );
  }
}
const SitesForm = Form.create()(SitesFormClass);

class Sites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      closed: false,
      rejectReason: '',
      editSites: undefined,
      size: 'large',
      flag: false,
      currentTab: 'All',
      searchText: '',
      siteSelected: null
    };
  }

  componentDidMount = () => {
    this.setState({ loading: true });

    Promise.all([this.fetchAllSites(), this.fetchAllSitesInventory()])
      .then(() => {
        this.setState({
          loading: false
        });

        window.addEventListener('resize', this.resizeEvent);

        if (window.cordova) {
          document.addEventListener('backbutton', this.handleBack);
        }
      })
      .catch(error => {
        console.error('Error during componentDidMount:', error);
        this.setState({ loading: false });
        Notify('error', 'Error', error.message || 'An error occurred');
      });
  };

  fetchAllSites = () => {
    return this.props.findAllSites().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };
  fetchAllSitesInventory = () => {
    return this.props.findAllSitesInventory().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };
  handleSearchCat = value => {
    this.setState({ searchText: value });
  };
  handleBack = () => {
    if (this.state.addSitesVisible) {
      this.setState({ addSitesVisible: false });
    } else {
      this.props.history.goBack();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  sitesForm;
  onAddSites = e => {
    this.setState({ addSitesVisible: true, editSites: undefined });
  };

  handleAddSites = e => {
    e.preventDefault();

    this.sitesForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        values.inventorySiteId = values.inventorySiteId
          ? String(values.inventorySiteId)
          : '';

        // ✅ Attach image
        values.mainCatImage = this.sitesForm.state.mainCatImage;

        // Guest Experience questions live in form state, not as form fields.
        // Drop blank rows so an unfinished "Add Question" doesn't get saved.
        values.experienceCriteria = (
          this.sitesForm.state.experienceCriteria || []
        )
          .filter(c => c && c.key && c.label && c.label.trim())
          .map(c => ({ key: c.key, label: c.label.trim() }));

        // ✅ Reconstruct dailyBudgets from budget_* values
        const selectedCategories = values.costCategories || [];
        const selectedCurrencies = values.availableCurrencies || [];
        const dailyBudgets = {};
        const exchange = {};

        selectedCategories.forEach(category => {
          const key = `budget_${category}`;
          if (values[key] !== undefined) {
            dailyBudgets[category] = values[key];
            delete values[key]; // 🔒 optional: clean up budget_Food etc. from payload
          }
        });
        selectedCurrencies.forEach(currency => {
          const key = `exchange_${currency}`;
          if (values[key] !== undefined) {
            exchange[currency] = values[key];
            delete values[key]; // 🔒 optional: clean up budget_Food etc. from payload
          }
        });

        values.dailyBudgets = dailyBudgets;
        values.exchange = exchange;

        // ✅ Attach ID if editing
        if (this.state.editSites) {
          values._id = this.state.editSites._id;
        }

        // 🔁 Continue with original flow
        this.props
          .addSites(values)
          .then(() => {
            this.props
              .findAllSites()
              .then(() => {
                Notify(
                  'success',
                  this.state.editSites
                    ? 'Successfully saved Site'
                    : 'Successfully added Site'
                );

                this.sitesForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  addSitesVisible: false,
                  editSites: undefined,
                  currentTab: 'All'
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };

  handleEditSites = e => {
    this.setState({ addSitesVisible: true, editSites: e });
  };

  handleDeleteSites = e => {
    const id = e.currentTarget.getAttribute('data');
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are you sure you want to delete this site?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteSites(id)
          .then(() => {
            that.props
              .findAllSites()
              .then(() => {
                that.setState({ loading: false, currentTab: 'All' });
                // that.props.find140mm();
                // that.props.find171mm();
                Notify('success', 'Successfully deleted Site');
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify('error', e);
          });
      },
      oncancel() {}
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });

  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };

  changeTypeTab = key => {
    this.setState({ currentTab: key });
  };

  render() {
    let descriptions = this.props.sites.map(site => {
      return { value: site.description };
    });
    const { size, siteSelected } = this.state;
    const { user } = this.props;
    let currentSites = [];

    const sites = this.props.sites || [];
    const accessList = (user.access || []).map(String);
    const selectedId = this.state.siteSelected
      ? String(this.state.siteSelected)
      : null;

    if (user.type === 'admin') {
      currentSites = sites;
    } else if (user.type === 'buyer' || user.type === 'user') {
      // ✅ show ALL accessible sites
      currentSites = sites.filter(site =>
        accessList.includes(String(site._id))
      );

      // ✅ ONLY narrow when user explicitly selects
      if (selectedId) {
        currentSites = currentSites.filter(
          site => String(site._id) === selectedId
        );
      }
    }

    const selectedSite = this.props.sites.find(
      site => site._id === this.state.siteSelected
    );

    const props = this.props.collapsed;
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        {/* {this.props.user.type !== 'admin' && (
          <img
            style={{
              height: props ? '8em' : '13em',
              width: props ? '9.8em' : '16.1em',
              transform: props ? 'scale(0.6)' : 'scale(0.65)',
              position: 'fixed',
              left: props ? '-1.8em' : '0em',
              top: props ? '-1em' : '-1.8em',
              transition: '0.2s',
              objectFit: 'contain'
            }}
            src={
              selectedSite && selectedSite.mainCatImage
                ? selectedSite.mainCatImage.includes('data')
                  ? selectedSite.mainCatImage
                  : process.env.REACT_APP_GLOBAL_SERVER +
                    'sproutmanagement/api/images/' +
                    selectedSite.mainCatImage
                : null
            }
            // alt="Site"
          />
        )} */}
        <Spin spinning={this.state.loading}>
          {this.state.addSitesVisible ? (
            <Card
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: this.props.isMobile ? 0 : '75em',
                    fontSize: this.props.isMobile ? '17px' : '20px',
                    fontWeight: 800,
                    whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                    fontFamily: 'Nunito'
                  }}
                >
                  {this.state.editSites ? 'Edit Site' : 'Add Site'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: this.props.isMobile ? '13px' : '16px',
                      whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editSites
                      ? "Remember to hit 'Save' to apply your edits"
                      : 'Ensure all fields are filled before saving to add a new Site'}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: this.props.isMobile ? 0 : '3em',
                width: this.props.isMobile ? '100%' : '70em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  padding: this.props.isMobile ? '1em' : '3em',
                  paddingTop: '1em',
                  paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <SitesForm
                  inventorySites={this.props.inventorySites}
                  descriptions={descriptions}
                  user={this.props.user}
                  editSites={this.state.editSites}
                  wrappedComponentRef={form => (this.sitesForm = form)}
                />{' '}
                <FloatButton.Group
                  trigger={this.props.isMobile ? 'click' : 'hover'}
                  type="primary"
                  style={{
                    right: 24
                  }}
                  icon={<RocketFilled />}
                >
                  <Tooltip placement="left" title="Save Item">
                    <FloatButton
                      onClick={this.handleAddSites}
                      icon={<PlusCircleFilled style={{ color: '#80CE90' }} />}
                    />
                  </Tooltip>
                  <Tooltip placement="left" title="Cancel">
                    <FloatButton
                      onClick={e => this.setState({ addSitesVisible: false })}
                      icon={<StopFilled style={{ color: 'red' }} />}
                    />
                  </Tooltip>
                </FloatButton.Group>
              </div>
            </Card>
          ) : (
            <Row style={{ marginTop: '1em' }}>
              <Col xs={24} lg={6}>
                <h1
                  style={{
                    marginBottom: '0em',
                    fontSize: '22px',
                    fontWeight: 800,
                    fontFamily: 'Nunito',
                    marginTop: '0.3em'
                  }}
                >
                  Site Management
                </h1>
              </Col>
              <Col xs={24} lg={18}>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '1em',
                    flexDirection: this.props.isMobile
                      ? 'row'
                      : 'row-reverse',
                    marginTop: this.props.isMobile ? '0.75em' : 0
                  }}
                >
                {this.props.user.type === 'admin' && (
                  <Button
                    type="primary"
                    onClick={this.onAddSites}
                    icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                    size="large"
                    style={{ width: this.props.isMobile ? '100%' : 'auto' }}
                  >
                    Add Site
                  </Button>
                )}
                {this.props.user.type === 'admin' && (
                  <Search
                    size="large"
                    placeholder="Search Site"
                    allowClear={false}
                    onSearch={this.handleSearchCat}
                    enterButton
                    style={{
                      width: this.props.isMobile ? '100%' : '20em'
                    }}
                    // value={this.state.searchText}
                  />
                )}
                </div>
              </Col>
              <Col span={24}>
                <StyledTable
                  bordered={false}
                  scroll={
                    this.props.isMobile
                      ? { x: 'max-content' }
                      : undefined
                  }
                  dataSource={currentSites
                    .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                    .filter(site =>
                      site.name
                        .toLowerCase()
                        .includes(this.state.searchText.toLowerCase())
                    )}
                  rowKey="_id"
                  size="middle"
                  pagination={
                    false
                    //defaultPageSize: 25,
                  }
                  style={{
                    minWidth: '15em',
                    marginTop: '1em'
                  }}
                >
                  <Column
                    // {...this.getColumnSearchProps('mainCatImage')}
                    title="Main Image"
                    dataIndex="mainCatImage"
                    key="mainCatImage"
                    render={(text, record) =>
                      record.mainCatImage ? (
                        <img
                          style={{
                            width: '3em',
                            height: '3em',
                            objectFit: 'contain'
                          }}
                          alt="example"
                          src={
                            record.mainCatImage.search('data') > -1
                              ? record.mainCatImage
                              : process.env.REACT_APP_GLOBAL_SERVER +
                                'sproutmanagement/api/images/' +
                                record.mainCatImage
                          }
                        />
                      ) : (
                        <div
                          style={{
                            marginTop: 8
                          }}
                        >
                          Upload
                        </div>
                      )
                    }
                  />
                  <Column
                    //{...this.getColumnSearchProps("name")}
                    title="Site Name"
                    dataIndex="name"
                    key="name"
                  />

                  <Column
                    //{...this.getColumnSearchProps("name")}
                    title="Currency"
                    dataIndex="companyCurrency"
                    key="companyCurrency"
                  />

                  <Column
                    //{...this.getColumnSearchProps("actions")}
                    title="Actions"
                    fixed={this.props.isMobile ? 'right' : undefined}
                    width={96}
                    render={(text, sites) => (
                      <span>
                        <EditFilled
                          style={{
                            backgroundColor: '#80CE90',
                            color: 'white',
                            padding: '0.5em',
                            borderRadius: '3em'
                          }}
                          onClick={e => this.handleEditSites(sites)}
                        />

                        <Divider type="vertical" />
                        {this.props.user.type === 'admin' && (
                          <DeleteFilled
                            style={{
                              backgroundColor: 'crimson',
                              color: 'white',
                              padding: '0.5em',
                              borderRadius: '3em'
                            }}
                            data={sites._id}
                            onClick={this.handleDeleteSites}
                          />
                        )}
                      </span>
                    )}
                  />
                </StyledTable>
              </Col>
            </Row>
          )}
        </Spin>
      </div>
    );
  }
}
const WrappedSites = Form.create()(withIsMobile(Sites));

const mapStateToProps = state => {
  return {
    collapsed: getSidebarCollapsed(state)
  };
};
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedSites);
